import { render, staticRenderFns } from "./CatalogUpdate.vue?vue&type=template&id=419f49e2"
import script from "./CatalogUpdate.vue?vue&type=script&lang=ts"
export * from "./CatalogUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports